import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { Category } from 'src/app/models/category';
import { CategoryService } from 'src/app/services/category.service';
import { Observable } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-courses',
  templateUrl: './add-courses.component.html',
  styleUrls: ['./add-courses.component.scss']
})
export class AddCoursesComponent implements OnInit {
  public selectedCourses=[];
  public courses:Course[];
  public categories: Category[];
  public selectedCategory:number;
  public loadingCourses:boolean=true;
  public loadingCats:boolean=true;

  constructor(
    public dialogRef: MatDialogRef<AddCoursesComponent>,
    private _cat: CategoryService
  ) { }

  getCourses(catId:number){
    this.loadingCourses = true;
    this._cat.getAllCategoryCourses(catId).subscribe(res=>{
      this.courses = res;
      this.loadingCourses = false;
    });
  }

  getCategories(){
    this._cat.getCategories().subscribe(
      res=>{
        this.categories=res;
        this.loadingCats=false;
      }
    );
  }

  public addCourses(value:any){
    value.forEach(course=>{
      if(!this.selected(course.id)) this.selectedCourses.push(course);
    });
  }

  private selected(needle) {
    var length = this.selectedCourses.length;
    for(var i = 0; i < length; i++) {
      if(this.selectedCourses[i].id == needle) return true;
    }
    return false;
  }

  public removeSelection(index:number){
    this.selectedCourses.splice(index, 1);
  }

  cancel(){
    this.dialogRef.close(false);
  }

  submit(){
    this.dialogRef.close(this.selectedCourses);
  }

  ngOnInit() {
    this.getCategories();
  }

}
